import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
}
export function StepIndicator({
  steps,
  currentStep
}: StepIndicatorProps) {
  return <div className="w-full max-w-3xl mx-auto px-6 py-8" data-id="element-40">
      <div className="relative flex items-center justify-between" data-id="element-41">
        {/* Background Line */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-0.5 bg-[var(--border)] -z-10" data-id="element-42" />

        {/* Active Progress Line */}
        <motion.div className="absolute left-0 top-1/2 -translate-y-1/2 h-0.5 bg-[var(--text-secondary)] -z-10 origin-left" initial={{
        scaleX: 0
      }} animate={{
        scaleX: currentStep / (steps.length - 1)
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-43" />

        {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        return <div key={step} className="flex flex-col items-center relative" data-id="element-44">
              <motion.div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 z-10`} initial={false} animate={{
            scale: isActive ? 1.1 : 1,
            backgroundColor: isActive ? 'var(--text-primary)' : isCompleted ? 'var(--text-secondary)' : 'var(--bg)',
            borderColor: isActive ? 'var(--text-primary)' : isCompleted ? 'var(--text-secondary)' : 'var(--border)',
            color: isActive || isCompleted ? 'var(--bg)' : 'var(--text-muted)'
          }} transition={{
            duration: 0.3
          }} data-id="element-45">
                {isCompleted ? <Check size={16} strokeWidth={3} data-id="element-46" /> : <span className="text-sm font-bold" data-id="element-47">{index + 1}</span>}
              </motion.div>

              <motion.span className={`absolute top-10 text-xs whitespace-nowrap ${isActive ? 'font-semibold text-[var(--text-primary)]' : 'font-medium text-[var(--text-muted)]'}`} animate={{
            opacity: isActive ? 1 : isCompleted ? 0.7 : 0.5
          }} data-id="element-48">
                {step}
              </motion.span>
            </div>;
      })}
      </div>
    </div>;
}